import { FC, useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import useAxios from "../../../hooks/useAxios";
import { IGetPublisher } from "../../../models/publishers.model";
import useLoader from "../../../hooks/useLoader";
import { getPublisher } from "../../../api/publishers.api";
import Header from "../../../components/layout/Header";
import PublisherForm from "../../../components/system/publisher/PublisherForm";
import { useTranslation } from "react-i18next";

interface IMatch {
  schoolCode: string;
};

const SystemPublisherEdit: FC = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const schoolCode = String(match.params.schoolCode);
  const { data: res, isLoading, error, execute } = useAxios<IGetPublisher>();
  useLoader(isLoading, [error]);

  useEffect(() => {
    if (schoolCode) {
      execute(getPublisher(schoolCode));
    }
  }, [schoolCode]);

  return (
    <div className="content-wrapper">
      <Header
        iconFile="icon-system-big.svg"
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.publisher.12')}
      />
      <PublisherForm
        data={res?.data}
      />
    </div>
  );
};

export default SystemPublisherEdit;